<template>
  <custom-dialog class="device-receipt-record-edit-device-dialog" width="1200px" :title="model.title" :visible="visible"
    v-on="$listeners">
    <div class="dialog-body">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 搜索项 -->
          <el-form-item style="float: right;">
            <search-input v-model="formSearch.consigneeOrgName" :placeholder="$t('crm_edit_device_dialog.shou_huo_gong_si')" @fetch="onPageChange({ page: 1 })"
              :authSearch="true"></search-input>
          </el-form-item>
          <!-- 机身号 -->
          <el-form-item style="float: right; ">
            <search-input v-model="formSearch.bodyNum" :placeholder="$t('crm_edit_device_dialog.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"
              :authSearch="true"></search-input>
          </el-form-item>
          <!-- 发货日期 -->
          <el-form-item style="float: right; ">
            <custom-date-picker style="width: 100%" :placeholder="$t('crm_edit_device_dialog.fa_huo_ri_qi')" v-model="formSearch.timer" type="daterange"
              align="right" value-format="YYYY-MM-DD HH:mm:ss" @change="onDateSelect"></custom-date-picker>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-bd">
        <custom-table :index="true" height="100%" :data="tableList" :tableCode="tableCode" @filter="filterChange"
          @sort="sortChange" :slots="['shipperTime']">
          <template v-slot:shipperTime="scope">
            <custom-date-picker :clearable="false" style="width: 100%" :placeholder="$t('crm_edit_device_dialog.fa_huo_ri_qi')"
              @change="onDateChange(scope.row)" v-model="scope.row.shipperTime" type="date" align="right"
              value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize"
          @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button :disabled="!changeRecords.length" type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'd_receipt_record_edit_device',
      formSearch: {
        // 发货日期
        timer: '',
        // 收货公司
        consigneeOrgName: '',
        // 机身号
        bodyNum: '',
        pageSize: 50,
        pageNum: 1,
      },
      totalRows: null,
      // 发货日期的修改，都会将对应的数据记录下来
      changeRecords: [],
      tableList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onDateChange(e) {
      const ids = this.changeRecords.map(item => item.dataId);
      if (ids.includes(e.dataId)) {
        const index = ids.findIndex(item => item === e.dataId);
        this.changeRecords.splice(index, 1, e);
      } else {
        this.changeRecords.push(e);
      }
    },
    onDateSelect() {
      this.onPageChange({ page: 1 });

    },
    init() {
      this.getTableList();
    },
    getSubmitReqData() {
      return this.changeRecords;
    },
    onConfirm() {
      this.$postJSON(apis.orderDeliveryMonthUpdate, this.getSubmitReqData()).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.close();
      });
    },
    onCancel() {
      this.close();
    },
    close() {
      this.$emit('close');
    },

    onPageChange: function ({ page, size }) {

      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getReqData() {
      const ret = { ...this.formSearch };
      if (this.formSearch.timer && this.formSearch.timer.length) {
        ret.shipperTimeStart = this.formSearch.timer[0];
        ret.shipperTimeEnd = this.formSearch.timer[1];
        delete ret.timer;
      }
      return ret;
    },
    // 将修改后的时间同步到列表数据
    updateList(newData, changeRecord) {
      newData.forEach((item) => {
        const itemInRecord = changeRecord.find(obj => obj.dataId === item.dataId);
        if (itemInRecord) {
          item.shipperTime = itemInRecord.shipperTime;
        }
        return newData;
      });
      return newData;

    },
    getTableList() {
      this.$getJSON(apis.orderDeliveryMonthEnableUpdatePage, this.getReqData()).then((res) => {
        this.tableList = this.updateList(res.data.list, this.changeRecords);
        this.totalRows = res.data.total;
      });
    },
  },
};
</script>

<style lang="scss">
.device-receipt-record-edit-device-dialog {
  .dialog-body{
    padding-bottom: 0 !important;
  }
  .search-hd {
    padding-top: 0 !important;
  }

  .table-bd {
    height: 400px;
  }
}
</style>
